// extracted by mini-css-extract-plugin
export default {"container":"loc_1Bn0D","count":"loc_cou_3DZka"};